import React from "react";
import { graphql } from "gatsby";
import IParagraphPageBanner from "./IParagraphPageBanner";
import PageBanner from "../../common/PageBanner/PageBanner";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";

const ParagraphPageBanner: React.FC<IParagraphPageBanner> = (node) => {
  const _banner = node.node;
  const _menu = node.menu;
  const minHeight = _banner.parent_type === "site" ? "480px" : "400px";
  const { isMobileOnly } = useMobileDetectContext();
  const _image = _banner.relationships.field_media
    ? isMobileOnly
      ? _banner.relationships.field_media.relationships.mobileImage.gatsbyImage
      : _banner.relationships.field_media.relationships.desktopImage.gatsbyImage
    : null;
  const _title = _banner.field_title ? _banner.field_title : "";
  const _secondary_title = _banner.field_secondary_title
    ? _banner.field_secondary_title
    : "";
  const _desc = _banner.field_description_formatted?.value;
  const _fieldLink = _banner.field_link;
  const _brand = _banner.relationships.brand;
  const _id = _banner.id;
  return (
    <>
      <PageBanner
        image={_image}
        title={_title}
        description={_desc}
        fieldLink={_fieldLink}
        minHeight={minHeight}
        menu={_menu}
        brand={_brand}
        id={_id}
        secondaryTitle={_secondary_title}
      />
    </>
  );
};

export const fragment = graphql`
  fragment ParagraphPageBanner on paragraph__page_banner {
    id
    parent_type
    field_title
    field_secondary_title
    field_description_formatted {
      value
    }
    field_link {
      url
      title
    }
    relationships {
      field_sites {
        machine_name
      }
      brand {
        field_fore_color {
          color
        }
        field_color {
          color
        }
        field_brandbars_bg_color {
          color
        }
        field_brandbars_fore_color {
          color
        }
        relationships {
          field_sites {
            machine_name
          }
        }
      }
      field_media {
        relationships {
          desktopImage: field_media_image {
            publicUrl
            gatsbyImage(
              width: 1440
              height: 480
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
          mobileImage: field_media_image {
            publicUrl
            gatsbyImage(
              width: 490
              height: 166
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
    }
  }
`;
export default ParagraphPageBanner;
